import { aG as r, bm as n, ax as e, aS as t } from "./StickyHeaderSkeleton-a0d7bfab.mjs";
function u(s) {
  const {
    lang: a
  } = r();
  return n({
    queryKey: [e.CLIENT_V1_COURSE_CATEGORY, {
      lang: a
    }, "GNB_COURSE_CATEGORIES"],
    url: t(e.CLIENT_V1_COURSE_CATEGORY),
    options: {
      ...s,
      suspense: !1,
      cacheTime: 1 / 0,
      staleTime: 1 / 0,
      useErrorBoundary: !1
    }
  });
}
export {
  u
};
